import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {storage, STORAGE_KEYS} from "@/utils/storage";
import {CancellationPoliciesContent} from "../Components/cancellationPoliciesContent.jsx";

export function CancellationPolicies({setStep, closeModal, previousStep}) {
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} backStep={previousStep || (storage.get(STORAGE_KEYS.PAYMENT_DETAILS_POLICIES) === true ? "paymentCards" : "policiesListing")} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <div className="modalPages-spacing pb-8">
                <CancellationPoliciesContent/>
            </div>
        </>
    );
}
export default CancellationPolicies;
